import { Modal, Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

// ============================================
// Styled Components
// ============================================
const ModalContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '340px',
  backgroundColor: '#fff',
  boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2)',
  borderRadius: '16px',
  padding: '32px',
  textAlign: 'center',
});

const MessageText = styled(Typography)({
  fontSize: '20px',
  fontWeight: 500,
  color: '#333',
  marginBottom: '24px',
});

const ConfirmButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'buttonColor',
})(({ buttonColor }) => ({
  width: '100%',
  height: '48px',
  borderRadius: '8px',
  backgroundColor: buttonColor,
  fontSize: '16px',
  fontWeight: 500,
  color: '#fff',
  '&:hover': {
    backgroundColor: buttonColor,
    opacity: 0.9,
  },
}));

// ============================================
// Main Component
// ============================================
/**
 * 알림 모달 컴포넌트
 * @param {boolean} open - 모달 열림 상태
 * @param {function} onClose - 모달 닫기 핸들러
 * @param {string} message - 표시할 메시지
 * @param {string} buttonText - 버튼 텍스트 (기본값: "확인")
 * @param {string} buttonColor - 버튼 색상 (기본값: "#4AB3BC")
 */
const AlertModal = ({ open, onClose, message, buttonText = '확인', buttonColor = '#4AB3BC' }) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <ModalContainer>
        <MessageText>{t(message)}</MessageText>
        <ConfirmButton onClick={onClose} buttonColor={buttonColor}>
          {t(buttonText)}
        </ConfirmButton>
      </ModalContainer>
    </Modal>
  );
};

export default AlertModal;
